module.exports = __webpack_public_path__ + "static/media/yewu-jiegou2.4eced61e.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/yewu-jiegou2.png
// module id = 599
// module chunks = 0